import _ from "lodash/fp";
import {combineActions, handleActions} from "redux-actions";
import {createTemplate} from "../templates/createTemplate";
import {fetchTemplates} from "../templates/fetchTemplates";

export default handleActions(
  {
    [combineActions(
      createTemplate.success,
      fetchTemplates.success)]: (state, {payload}) => _.merge(state, payload),
  },
  {}
)
